import ExportContractJobView from "@/views/export_data/ExportContractJobView.vue";
import ExportUserView from "@/views/export_data/ExportUserView.vue";
import ExportVehicleView from "@/views/export_data/ExportVehicleView.vue";

export default [
  {
    path: "/export-data/contract-job",
    name: "exportContractJobList",
    component: ExportContractJobView,
    meta: { requiresAuth: true, topic: "exportContractJob" },
  },
  {
    path: "/export-data/user",
    name: "exportUserList",
    component: ExportUserView,
    meta: { requiresAuth: true, topic: "exportUser" },
  },
  {
    path: "/export-data/vehicle",
    name: "exportVehicleList",
    component: ExportVehicleView,
    meta: { requiresAuth: true, topic: "exportVehicle" },
  },
];
